import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';

import user from './reducers/userReducer';
import role from './reducers/roleReducer';
import permission from './reducers/permissionReducer';
import application from './reducers/applicationReducer';
import organization from './reducers/organizationReducer';
import customerGroup from './reducers/customerGroupReducer';
import invitation from './reducers/invitationReducer';
import table from './reducers/tableReducer';

const appReducer = combineReducers({
  user,
  role,
  permission,
  application,
  organization,
  customerGroup,
  table,
  invitation,
  toastr,
});

export default appReducer;
